import http from '@/utils/http'

export function loginbyUser(
  syncTimeStart,
  syncTimeEnd,
  cardNo,
  vehicleNo,
  page,
  pageSize
) {
  const data = {
    syncTimeStart,
    syncTimeEnd,
    cardNo,
    vehicleNo,
    page,
    pageSize
  }
  return http({
    url: '/bi-api/abnormal/querySingle',
    method: 'post',
    data
  })
}
